
import { Vue, Component } from 'vue-property-decorator'
import { ClueService } from '@/services'
import { ElForm } from 'element-ui/types/form'
import { isValidURL } from '@/common/utils'

enum Title {
    add = '增加数据源',
    update = '修改数据源'
}

enum Type {
    add = 'add',
    update = 'update'
}

@Component({})
export default class SourceSetting extends Vue {
    private title = Title.add
    private type = ''
    private sId: any = ''
    private dataSortList = []
    private channelId = 0
    private sourceForm = {
        name: '',
        clue_source_type_id: '',
        official_url: '',
        is_generic: false
    }
    private sourceRules = {
        name: [
            { required: true, validator: this.nameValidator, trigger: 'change' }
        ],
        clue_source_type_id: [
            { required: true, message: '类别为必选项' }
        ],
        official_url: [
            { required: true, validator: this.urlValidator, trigger: 'change' }
        ]
    }

    get sourceRef() {
        return this.$refs.sourceRef as ElForm
    }

    private nameValidator(rule: any, value: string, callback: Function) {
        let message = '请输入正确的名称'
        if (!value) {
            return callback(message)
        } else if (value.length < 2) {
            message = '至少2个字符以上'
            return callback(message)
        } else if (value.length > 30) {
            message = '长度限制在30个字符以内'
            return callback(message)
        }
        callback()
    }

    private urlValidator(rule: any, value: string, callback: Function) {
        // 检验网址
        let message = '请输入正确的链接地址'
        if (!value) return callback(message)
        if (!isValidURL(value)) {
            return callback(message)
        }
        callback()
    }

    private created() {
        const { type } = this.$route.params
        const { id, sid } = this.$route.query
        this.channelId = +id
        this.type = type
        this.title = type === Type.add ? Title.add : Title.update
        this.sId = sid
    }

    private async mounted() {
        // 先加载类别列表，再加载详情，确保下拉框能正确选中
        await this.getClueTypeList()
        if (this.sId) {
            await this.getSourceDetail()
        }
    }

    // 获取线索类别列表
    private async getClueTypeList() {
        const result = await ClueService.getDataSourceSortList()
        if (result.status === 200) {
            this.dataSortList = result.data
        }
    }

    // 获取数据源详情
    private async getSourceDetail() {
        const params = { id: this.sId }
        const result = await ClueService.getChannelSourceDetail(params)
        if (result.status === 200 && result.data) {
            const data = result.data

            // 兼容 camelCase 和 snake_case 两种命名格式
            const name = data.name
            const officialUrl = data.official_url || data.officialUrl || ''
            const sourceTypeId = data.clue_source_type_id || data.clueSourceTypeId || ''
            const isGeneric = data.is_generic || data.isGeneric || false

            this.sourceForm = {
                name: name || '',
                clue_source_type_id: sourceTypeId,
                official_url: officialUrl,
                is_generic: isGeneric
            }
        }
    }

    // 创建数据源
    private async createClueSource() {
        const params = {
            ...this.sourceForm,
            clue_source_type_id: +this.sourceForm.clue_source_type_id,
            channel_id: this.channelId
        }
        const result = await ClueService.createChannelSource(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '数据源创建成功',
                showClose: true
            })
            return true
        }
        return false
    }

    private async updateClueSource() {
        const params = {
            ...this.sourceForm,
            clue_source_type_id: +this.sourceForm.clue_source_type_id,
            id: +this.sId
        }
        const result = await ClueService.updateChannelSource(params)
        if (result.status === 200) {
            this.$message({
                type: 'success',
                message: '修改成功',
                showClose: true
            })
            return true
        }
        return false
    }

    private onSave() {
        this.sourceRef.validate(async (isVaild: boolean) => {
            let result
            if (isVaild) {
                switch (this.type) {
                    case Type.add:
                        result = await this.createClueSource()
                        result && this.$router.go(-1)
                        break
                    case Type.update:
                        result = await this.updateClueSource()
                        result && this.$router.go(-1)
                        break
                    default:
                        break
                }
                
            }
        })
    }


}
